import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import TeamExams from '@/views/exam/List.vue';

export const teamExamsManageRoute: RouteConfig = {
  path: 'examsManage',
  name: 'teamExamsManage',
  component: TeamExams,
  meta: { title: 'titles.team.examManage' },
  beforeEnter: (to: any, from: any, next: any) => {
    store.commit('exam/setFilters', {
      teamId: tryParseInt(to.params.teamId),
      inheritedFromClub: undefined,
      clubId: undefined
    });
    store
      .dispatch('sport/list', { count: -1 })
      .then(() => next())
      .catch(() => store.dispatch('notifyError', { title: 'messages.sport.listError' }));
  }
};
